import { CompactInput, PropertiesPanelControl, PropertiesPanelLabel, PropertiesPanelProperty } from './propertiesPanelProperty';
import React from 'react';
import { Icon } from 'src/components/widgets/icon';
import { ResetIcon as ResetSolid } from 'src/components/widgets/icons/scene';
import { styled } from 'styled-components';

export const PropertiesPanelTextIcon = styled(Icon)`
    position: absolute;
    right: 10px;
    cursor: pointer;
    width: 16px;
`;

export type PropertiesPanelTextPropertyProps = {
    id: string;
    label: React.ReactNode;
    value: string;
    onChange?: (newValue: string, e?: React.ChangeEvent<HTMLInputElement>) => void;
    disabled?: boolean;
    reset?: boolean;
    initialValue?: string;
};
export const PropertiesPanelTextProperty: React.FC<PropertiesPanelTextPropertyProps> = ({ id, label, value, onChange, disabled, reset, initialValue }) => {
    return (
        <PropertiesPanelProperty>
            <PropertiesPanelLabel htmlFor={`${id}-input`}>{label}</PropertiesPanelLabel>
            <PropertiesPanelControl>
                {/* Invio conferma ed esce, come il nome nella testata dell'Inspector: il valore è già scritto
                    a ogni tasto, quindi uscire è tutta la conferma. */}
                <CompactInput
                    id={`${id}-input`}
                    type='text'
                    value={value}
                    onChange={(e) => onChange?.(e.target.value, e)}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') e.currentTarget.blur();
                    }}
                    disabled={disabled}
                />
                {reset && (
                    <PropertiesPanelTextIcon
                        onClick={() => {
                            value = initialValue ?? '';
                            onChange?.(initialValue ?? '', undefined);
                        }}
                    >
                        <ResetSolid />
                    </PropertiesPanelTextIcon>
                )}
            </PropertiesPanelControl>
        </PropertiesPanelProperty>
    );
};
